import { Routes, Route } from 'react-router-dom';

import { useAppSelector } from '@/app/store';

import Channels from '@/pages/Channels/Channels';
import Channel from '@/pages/Channels/Channel';
import ChannelLists from '@/pages/ChannelLists/ChannelLists';
import ChannelList from '@/pages/ChannelLists/ChannelList';
import Projects from '@/pages/Projects/Projects';
import Project from '@/pages/Projects/Project';
import MwLight from '@/pages/MwLight/MwLight';
import Users from '@/pages/Users/Users';
import Apps from '@/pages/Settings/Apps';
import Epg from '@/pages/Settings/Epg';
import Audit from '@/pages/Settings/Audit/Audit';
import Tags from '@/pages/Settings/Tags';
import Languages from '@/pages/Settings/Languages';
import Platform from '@/pages/Settings/Platform';
import Firmwares from '@/pages/Settings/Firmware/Firmwares';
import TrackFormats from '@/pages/Settings/TrackFormats';
import CloneSettings from '@/pages/Settings/CloneSettings';
import TwoFactor from '@/pages/Settings/TwoFactor';
import Mailer from '@/pages/Settings/Mailer';
import Monitoring from '@/pages/Settings/Monitoring';
import System from '@/pages/Settings/System';
import Deleted from '@/pages/Settings/Deleted';

const Routing = () => {
  // Server-wide 2FA capability: the two-factor route only exists when the
  // backend reports supports_2fa === true (false/absent → hidden).
  const supports2FA = useAppSelector((s) => s.logins.supports2FA);
  return (
    <Routes>
      <Route path="*" element={<Projects />} />
      <Route path="/projects" element={<Projects />} />
      //<Route path="/projects/:id/:tab?" element={<Project />} />
      //<Route path="/projects/:id/:tab/:tab_no?" element={<Project />} />
      <Route path="/projects/:id/:tab?/:tab_no?/:sub_tab?" element={<Project />} />
      <Route path="/hotels" element={<Projects />} />
      //<Route path="/hotels/:id/:tab?" element={<Project />} />
      //<Route path="/hotels/:id/:tab/:tab_no?" element={<Project />} />
      <Route path="/hotels/:id/:tab?/:tab_no?/:sub_tab?" element={<Project />} />
      {/* MW light (#91, §2.4) — the room list with a Checkout button, and the
          only page of that project its MW light users can reach. */}
      <Route path="/mw_light/:id" element={<MwLight />} />
      <Route path="/channels" element={<Channels />} />
      <Route path="/channels/:epg_id" element={<Channel />} />
      <Route path="/channels/:epg_id/searchproject" element={<Channel />} />
      <Route path="/channels/:epg_id/:tab" element={<Channels />} />
      <Route path="/channel_lists" element={<ChannelLists />} />
      <Route path="/channel_lists/:epg_id" element={<ChannelLists />} />
      <Route path="/channel_lists/:epg_id/:op" element={<ChannelList />} />
      <Route path="/users" element={<Users />} />
      <Route path="/users/:user" element={<Users />} />
      <Route path="/settings/apps" element={<Apps />} />
      <Route path="/settings/apps/:app_id" element={<Apps />} />
      <Route path="/settings/epg" element={<Epg />} />
      <Route path="/settings/tags" element={<Tags />} />
      <Route path="/settings/tags/:tag_id" element={<Tags />} />
      <Route path="/settings/languages" element={<Languages />} />
      <Route path="/settings/languages/:lang_code" element={<Languages />} />
      <Route path="/settings/statistics" element={<Platform/>}/>
      <Route path="/settings/statistics/:tab" element={<Platform/>}/>
      <Route path="/settings/statistics/:platform/searchproject" element={<Platform/>}/>
      <Route path='/audit' element={<Audit/>} />
      <Route path="/settings/firmware"  element={<Firmwares/>} />
      <Route path="/settings/trackformats" element={<TrackFormats/>} />
      <Route path="/settings/trackformats/:tf_key" element={<TrackFormats/>} />
      <Route path="/settings/trackformats/:tf_key/searchchannel" element={<TrackFormats/>} />
      <Route path="/settings/trackformats/:tf_key/searchproject" element={<TrackFormats/>} />
      <Route path="/settings/clonesettings" element={<CloneSettings/>} />
      { supports2FA &&
        <Route path="/settings/two-factor" element={<TwoFactor/>} />
      }
      <Route path="/settings/mailer" element={<Mailer/>} />
      <Route path="/settings/monitoring" element={<Monitoring/>} />
      <Route path="/settings/system" element={<System/>} />
      <Route path="/settings/deleted" element={<Deleted/>} />
    </Routes>
  );
};

export default Routing;
